module.exports = __webpack_public_path__ + "static/media/code-icon.4e68e03c.svg";